import { Component, OnInit } from '@angular/core';
import {CoreService} from "../../../../services/core.service";

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.sass']
})
export class NotFoundComponent implements OnInit {

  constructor(private coreServices: CoreService) {
  }

  ngOnInit() {
    // Delay deactivation of globalLoading to ensure component is fully initialized
    setTimeout(() => {
      this.coreServices.disableGlobalLoading();
    }, 100);
  }
}
